angular.module('ihestiaWidgets.ikonfigurator', [
  'ui.router',
  'ab-base64',
  'ihestia-widgets-templates-app'
]);